import { render, staticRenderFns } from "./OptGroup.vue?vue&type=template&id=2662b69a&"
import script from "./OptGroup.vue?vue&type=script&lang=js&"
export * from "./OptGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports